<div class="block-header justify-between relative">
    <div class="flex flex-row items-center">
        <div *ngIf="icon" class="icon-container">
            <img [src]="icon?.url">
        </div>
        <div class="block-header__title">{{ name }}</div>
        <div class="ctag ms-3 uppercase" *ngIf="tag">{{ tag }}</div>
    </div>
    <!-- <div class="block-header__divider"></div> -->

    <ul *ngIf="headers?.length > 1" class="block-header__groups-list realEstate-header">
        <li *ngFor="let header of headers; let index = index;">
            <button type="button" class="block-header__group" [ngClass]="{'block-header__group--active': index == blockProductCarouselService.selectedHeaderValue}" (click)="setHeader(index)">{{ translateHelper.localize(header) }}</button>
        </li>
    </ul>

    <div *ngIf="arrows" class="block-header__arrows-list">
        <button class="block-header__arrow block-header__arrow--left" type="button" (click)="prev.emit()">
            <app-icon name="arrow-rounded-left-7x11" size="7x11"></app-icon>
        </button>
        <button class="block-header__arrow block-header__arrow--right" type="button" (click)="next.emit()">
            <app-icon name="arrow-rounded-right-7x11" size="7x11"></app-icon>
        </button>
    </div>
</div>